import { useSelector } from 'react-redux'

const useGoalsAccess = (): boolean => {
  const goals: boolean | undefined = useSelector(
    (state: any) => state.global.home.goals
  )

  return Boolean(goals)
}

export default useGoalsAccess
